/**
 * Created by alex.shmaltsuev on 2016-06-14.
 */
import C from  '../constants/intl';
import { dispatchAjaxResponseWithCharger} from '../utils/helpers';

export function initUserIntl() {
    let url ='api/v1/rb/userLocale?prefix=ssp';
    return dispatchAjaxResponseWithCharger(url,C.GET_SSP_INTL);
}


// WEBPACK FOOTER //
// ./actions/intl.js